import { backgroundColorModal, backgroundColorWhite, ColorError, borderColorNormal } from './palette';

export const createInquiryFieldBg = backgroundColorModal;
export const createInquirySelectBg = backgroundColorWhite;

export const createInquiryError = ColorError;

export const createInquiryAttachBg = backgroundColorWhite;
export const createInquiryAttachBorder = borderColorNormal;
